export const ADD_GUEST_FORM_FIELDS = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  gender: {
    label: "",
    value: "",
  },
};
